/* ==========================================================================
   SENTYR SKIN — el-common.js (socle, port du el-common.js Penrose)
   Dépend de jQuery 3.7.1 + Slick 1.9.0 chargés dans layout/theme.liquid.
   Retiré volontairement : fixSubscriptionMix (abonnement non reproduit),
   removePaidFreeProducts (ids de variantes Penrose en dur).
   ========================================================================== */
(function ($) {
  'use strict';
  if (!$) return;

  /* ---------- Sliders génériques : [data-slider-config] ---------- */
  function elInitSliders(scope) {
    var $scope = scope ? $(scope) : $(document);
    $scope.find('[data-slider-config]').each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized') || typeof $slider.slick !== 'function') return;
      var config = $slider.data('slider-config');
      if (typeof config === 'string') {
        try { config = JSON.parse(config); } catch (e) { config = {}; }
      }
      $slider.slick(config || {});
    });
  }
  window.elInitSliders = elInitSliders;

  $(function () {
    elInitSliders();
    if (navigator.userAgent.indexOf('Mac') > 0) $('body').addClass('mac-os');
    else $('body').addClass('window-os');
    updateCartCountExcludeShipping();
    removeShippingProtection();
    elInitCountdowns();
  });

  /* ---------- Vidéo : bouton lecture ---------- */
  $(document).on('click', '.el-play-button', function () {
    var $btn = $(this);
    var $wrapper = $btn.parents('.el-video-wrapper');
    var video = $wrapper.find('video');
    if ($btn.hasClass('active')) {
      $wrapper.removeClass('active');
      $btn.removeClass('active');
      video.trigger('pause');
    } else {
      video.trigger('play');
      $wrapper.addClass('active');
      $btn.addClass('active');
    }
  });

  /* ---------- Header transparent sur l'accueil (body.el-hp-body) ---------- */
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 30) $('body').addClass('remove_transparent');
    else $('body').removeClass('remove_transparent');
  });

  /* ---------- FAQ accordéon ---------- */
  $(document).on('click', '.el-question', function () {
    var $q = $(this);
    if ($q.hasClass('active')) {
      $q.toggleClass('active');
      $q.next().slideToggle();
    } else {
      $('.el-question').removeClass('active');
      $('.el-question').next().slideUp();
      $q.toggleClass('active');
      $q.next().slideToggle();
    }
    $('.el-question').attr('aria-expanded', 'false');
    $('.el-question.active').attr('aria-expanded', 'true');
  });

  /* ---------- Ancres ---------- */
  $(document).on('click', "a[href='/#faq'], a[href='#faq']", function (e) {
    var target = document.querySelector('.el-faq');
    if (target) {
      e.preventDefault();
      $('button.el-mobile-menu-close').trigger('click');
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
  $(document).on('click', "a[href='#reviews']", function (e) {
    var target = document.querySelector('#reviews');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
  });
  $(document).on('click', ".el-hp-body a[href='#']", function (e) {
    var target = document.querySelector('.el-product-label');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
  });

  /* ---------- Menu tiroir ---------- */
  var menuReturnFocus = null;
  function cancelDrawerFocus(drawer) {
    var pending = drawer && drawer.__elFocusPending;
    if (!pending) return;
    window.cancelAnimationFrame(pending.frame);
    window.clearTimeout(pending.timer);
    drawer.removeEventListener('transitionend', pending.onTransition);
    drawer.__elFocusPending = null;
  }
  function scheduleVisibleDrawerFocus(drawer, focus) {
    cancelDrawerFocus(drawer);
    var pending = {};
    drawer.__elFocusPending = pending;
    function attempt(finalAttempt) {
      if (drawer.__elFocusPending !== pending) return;
      if (!drawer.isConnected || !drawer.classList.contains('active')) { cancelDrawerFocus(drawer); return; }
      // Do not replace a focus that the visitor has already chosen inside the drawer.
      if (drawer.contains(document.activeElement) && document.activeElement !== drawer) { cancelDrawerFocus(drawer); return; }
      var allowed = focus();
      if (allowed === false || finalAttempt || drawer.contains(document.activeElement)) cancelDrawerFocus(drawer);
    }
    pending.onTransition = function (event) { if (event.target === drawer) attempt(false); };
    drawer.addEventListener('transitionend', pending.onTransition);
    // Visibility is part of the existing .5 s transition; one frame can still be hidden.
    pending.frame = window.requestAnimationFrame(function () {
      pending.frame = window.requestAnimationFrame(function () { attempt(false); });
    });
    pending.timer = window.setTimeout(function () { attempt(true); }, 650);
  }
  function openMenu() {
    menuReturnFocus = document.activeElement;
    $('.el-drawer-menu').prop('inert', false).attr('aria-hidden', 'false').addClass('active');
    $('.el-mobile-menu-button').attr('aria-expanded', 'true');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
    var menu = document.querySelector('.el-drawer-menu.active');
    if (menu) scheduleVisibleDrawerFocus(menu, function () {
      if (cartHasForegroundModal(null, true)) return false;
      var close = menu.querySelector('.el-mobile-menu-close');
      if (close) close.focus({ preventScroll: true });
    });
  }
  function closeMenu() {
    cancelDrawerFocus(document.querySelector('.el-drawer-menu.active'));
    $('.el-drawer-menu').removeClass('active').prop('inert', true).attr('aria-hidden', 'true');
    $('.el-mobile-menu-button').attr('aria-expanded', 'false');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
    if (menuReturnFocus && menuReturnFocus.isConnected) menuReturnFocus.focus();
    menuReturnFocus = null;
  }
  $(document).on('click', '.el-mobile-menu-button', openMenu);
  $(document).on('click', '.el-mobile-menu-close, .el-drawer-menu-bg', closeMenu);
  $(document).on('keydown', function (e) {
    var menu = document.querySelector('.el-drawer-menu.active');
    if (!menu) return;
    if (e.key === 'Escape') { e.preventDefault(); closeMenu(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.from(menu.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]')).filter(function (item) { return item.getClientRects().length; });
    var first = items[0], last = items[items.length - 1];
    if (!first) return;
    if (!menu.contains(document.activeElement) || document.activeElement === menu) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Shopify's native preference dialog; never navigate to the policies index. */
  var privacyScriptPromise;
  $(document).on('click', '[data-sentyr-cookie-preferences]', function () {
    var button = this;
    var status = document.getElementById('sentyr-cookie-status');
    if (status) status.textContent = '';
    button.disabled = true;
    if (!privacyScriptPromise) {
      privacyScriptPromise = new Promise(function (resolve, reject) {
        if (window.privacyBanner && window.privacyBanner.showPreferences) { resolve(); return; }
        var script = document.querySelector('script[src*="privacy-banner/storefront-banner.js"]');
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.async = true;
          script.dataset.sentyrPrivacy = 'true';
          document.head.appendChild(script);
        }
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', function () {
          if (script.dataset.sentyrPrivacy === 'true') script.remove();
          reject(new Error('Privacy script unavailable'));
        }, { once: true });
        setTimeout(function () {
          if (window.privacyBanner && window.privacyBanner.showPreferences) resolve();
          else {
            if (script.dataset.sentyrPrivacy === 'true') script.remove();
            reject(new Error('Privacy preferences unavailable'));
          }
        }, 6000);
      });
    }
    privacyScriptPromise.then(function () { return window.privacyBanner.showPreferences(); }).catch(function () {
      privacyScriptPromise = null;
      if (status) status.textContent = 'Les préférences n’ont pas pu s’ouvrir. Réessaie dans quelques instants.';
    }).finally(function () { button.disabled = false; });
  });

  /* ---------- Fiche produit : sélecteurs d'options (utilisés par el-pdp) ---------- */
  $(document).on('click', '.el-element-option-option-item-right', function () {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });
  $(document).on('click', '.el-product-option-list-item', function () {
    var $item = $(this);
    var $list = $item.parents('.el-product-option-list-main');
    $list.prev().toggleClass('active');
    $list.slideToggle();
    var variant_id = $item.attr('variant_id');
    var selling_plan = $item.attr('selling_plan');
    var variant_title = $item.find('.el-product-option-list-title').text();
    var variant_scent = $item.find('.el-product-option-list-inspired').html();
    var current_detail = $list.prev();
    current_detail.find('.el-product-option-title>span:first-child').text(variant_title);
    current_detail.find('.el-product-option-inspired').html(variant_scent);
    current_detail.find('.el-product-option').attr('variant_id', variant_id);
    current_detail.find('.el-product-option').attr('selling_plan', selling_plan);
  });
  $(document).on('click', '.el-element-option', function () {
    var $opt = $(this);
    var $product = $opt.parents('.el-product');
    $product.find('.el-element-option').removeClass('active');
    $opt.addClass('active');
    var data_tab = $opt.attr('data_tab');
    $product.find('.el-quantity-data').hide();
    $product.find('.el-quantity-data[data_tab="' + data_tab + '"]').show();
  });
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.el-product-option-list').length && !$(e.target).closest('.el-element-option-option-item-right').length) {
      $('.el-product-option-list').parents('.el-product-option-list-main').prev().removeClass('active');
      $('.el-product-option-list').parents('.el-product-option-list-main').slideUp();
    }
  });
  $(document).on('click', "a[href='#guide']", function (e) {
    e.preventDefault();
    $('.el-drawer-guide').addClass('active');
    $('.el-drawer-guide-bg').show();
  });
  $(document).on('click', '.el-mobile-guide-close, .el-drawer-guide-bg', function () {
    $('.el-drawer-guide').removeClass('active');
    $('.el-drawer-guide-bg').hide();
  });

  /* ---------- Panier : ouverture / fermeture ---------- */
  var cartReturnFocus = null;
  var CART_FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function cartHasForegroundModal(event, ignoreMenu) {
    var nativeEvent = event && (event.originalEvent || event);
    var path = nativeEvent && typeof nativeEvent.composedPath === 'function' ? nativeEvent.composedPath() : [];
    if (path.some(function (node) { return node && node.tagName === 'DIALOG' && node.open; })) return true;
    if (document.querySelector(ignoreMenu ? 'dialog[open]' : '.el-drawer-menu.active, dialog[open]')) return true;
    var game = document.getElementById('sentyr-game-host');
    return !!(game && game.shadowRoot && game.shadowRoot.querySelector('dialog[open]'));
  }
  function cartFocusable(drawer) {
    return Array.from(drawer.querySelectorAll(CART_FOCUSABLE)).filter(function (item) {
      return item.getClientRects().length && !item.closest('[inert], [aria-hidden="true"]') && item.tabIndex >= 0;
    });
  }
  function focusCartStart(drawer) {
    if (cartHasForegroundModal()) return;
    var target = drawer.querySelector('.el-mobile-cart-close') || cartFocusable(drawer)[0] || drawer;
    target.focus({ preventScroll: true });
  }
  function cartFocusSnapshot(drawer) {
    var active = document.activeElement;
    if (!active || !drawer.contains(active)) return null;
    var line = active.closest('.el-line-item');
    var control = ['el-quantity-plus', 'el-quantity-minus', 'el-quantity-input', 'el-line-item-remove', 'el-mobile-cart-close'].find(function (name) { return active.classList.contains(name); });
    return { key: line && line.getAttribute('data-key'), control: control, id: active.id, href: active.getAttribute('href'), checkout: active.getAttribute('name') === 'checkout' };
  }
  function restoreCartFocus(drawer, snapshot) {
    if (!drawer.classList.contains('active') || cartHasForegroundModal()) return;
    var target = null;
    if (snapshot) {
      var scope = drawer;
      if (snapshot.key) scope = Array.from(drawer.querySelectorAll('.el-line-item')).find(function (line) { return line.getAttribute('data-key') === snapshot.key; });
      if (scope && snapshot.control) target = scope.querySelector('.' + snapshot.control);
      if (!target && snapshot.id) target = document.getElementById(snapshot.id);
      if (!target && snapshot.href) target = Array.from(drawer.querySelectorAll('a[href]')).find(function (link) { return link.getAttribute('href') === snapshot.href; });
      if (!target && snapshot.checkout) target = drawer.querySelector('[name="checkout"]');
    }
    if (target && drawer.contains(target) && !target.disabled && target.getClientRects().length) target.focus({ preventScroll: true });
    else if (!drawer.contains(document.activeElement)) focusCartStart(drawer);
  }
  function scheduleCartFocus(drawer, snapshot) {
    if (snapshot) drawer.__elCartFocusSnapshot = snapshot;
    scheduleVisibleDrawerFocus(drawer, function () {
      if (cartHasForegroundModal()) { drawer.__elCartFocusSnapshot = null; return false; }
      restoreCartFocus(drawer, drawer.__elCartFocusSnapshot);
      if (drawer.contains(document.activeElement)) drawer.__elCartFocusSnapshot = null;
    });
  }
  function openCart(trigger, options) {
    var drawer = document.querySelector('.el-cart-drawer');
    if (!drawer || cartHasForegroundModal()) {
      if (drawer && options && options.afterAdd) refreshCartDrawer();
      return;
    }
    if (!drawer.classList.contains('active')) {
      var origin = trigger && typeof trigger.focus === 'function' ? trigger : document.activeElement;
      cartReturnFocus = origin && origin !== document.body && origin !== document.documentElement ? origin : document.querySelector('.el-cart-button');
    }
    $('.el-cart-drawer').prop('inert', false).attr('aria-hidden', 'false').addClass('active');
    $('.el-cart-button').attr('aria-expanded', 'true').attr('aria-haspopup', 'dialog').attr('aria-controls', drawer.id);
    $('.el-drawer-cart-bg').show();
    $('body').addClass('el-overflow-hidden');
    scheduleCartFocus(drawer, { control: 'el-mobile-cart-close' });
    refreshCartDrawer(options && options.afterAdd ? undefined : { readOnly: true });
  }
  function closeCart() {
    var drawer = document.querySelector('.el-cart-drawer.active');
    if (!drawer) return;
    cancelDrawerFocus(drawer);
    drawer.__elCartFocusSnapshot = null;
    var target = cartReturnFocus && cartReturnFocus.isConnected && !cartReturnFocus.disabled ? cartReturnFocus : document.querySelector('.el-cart-button');
    // Move focus before hiding the tree, avoiding aria-hidden on a focused descendant.
    if (!cartHasForegroundModal() && target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    $('.el-cart-drawer').removeClass('active').prop('inert', true).attr('aria-hidden', 'true');
    $('.el-cart-button').attr('aria-expanded', 'false');
    $('.el-drawer-cart-bg').hide();
    if (!cartHasForegroundModal()) $('body').removeClass('el-overflow-hidden');
    cartReturnFocus = null;
  }
  window.elOpenCart = openCart;
  window.elCloseCart = closeCart;
  $(document).on('click', '.el-cart-button', function () {
    if ($('.el-cart-drawer-js').length) openCart(this);
  });
  $(document).on('click', ".el-mobile-cart-close, .el-drawer-cart-bg, a[href='#close_cart']", function (e) {
    e.preventDefault();
    closeCart();
  });
  $(document).on('keydown', function (e) {
    var drawer = document.querySelector('.el-cart-drawer.active');
    if (!drawer || cartHasForegroundModal(e)) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeCart(); return; }
    if (e.key !== 'Tab') return;
    var items = cartFocusable(drawer);
    var first = items[0], last = items[items.length - 1];
    if (!first) { e.preventDefault(); drawer.focus({ preventScroll: true }); return; }
    var active = document.activeElement;
    if (!drawer.contains(active) || active === drawer) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Panier : ajout rapide (.el-atc-js, attribut variant_id) ---------- */
  var cartWriteBusy = false;
  var cartWriteAwaitingRead = false;
  var cartErrorMessage = '';
  function setCartError(message) {
    cartErrorMessage = message || '';
    var box = document.querySelector('[data-el-cart-error]');
    if (!box) return;
    var text = box.querySelector('[data-el-cart-error-message]');
    if (text) text.textContent = cartErrorMessage;
    box.hidden = !cartErrorMessage;
    if (cartErrorMessage && typeof box.scrollIntoView === 'function') box.scrollIntoView({ behavior: 'auto', block: 'nearest' });
  }
  function cartWriteError(err) {
    return err && err.status === 422
      ? 'Cette modification a été refusée. Vérifie les quantités disponibles, puis réessaie.'
      : 'La connexion a été interrompue. Vérifie ton panier avant de réessayer : l’action a peut-être été enregistrée.';
  }
  function beginCartWrite() {
    if (cartWriteBusy) return false;
    cartWriteBusy = true;
    cartWriteAwaitingRead = false;
    setCartError('');
    $('.el-cart-drawer-js').addClass('el-loading-cart');
    return true;
  }
  function failedCartWrite(err) {
    setCartError(cartWriteError(err));
    // Reconcile with a GET only: never replay a possibly accepted POST.
    refreshCartDrawer({ readOnly: true, preserveError: true, releaseWrite: true });
  }
  function elAddItems(items, $btn) {
    if (!beginCartWrite()) return;
    if ($btn) $btn.addClass('el-loading').prop('disabled', true).attr('aria-busy', 'true');
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: items }),
      dataType: 'json',
      contentType: 'application/json',
      timeout: 12000
    }).done(function () {
      openCart();
      refreshCartDrawer({ releaseWrite: true });
    }).fail(function (err) {
      // A quick-add may live outside the drawer; reveal its feedback on failure.
      if (!document.querySelector('.el-cart-drawer.active')) openCart($btn && $btn[0]);
      failedCartWrite(err);
    }).always(function () {
      if ($btn) $btn.removeClass('el-loading').prop('disabled', false).attr('aria-busy', 'false');
    });
  }
  window.elAddItems = elAddItems;

  $(document).on('click', '.el-atc-js', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var variant_id = parseInt($btn.attr('variant_id'), 10);
    if (!variant_id) return;
    var qty = parseInt($btn.attr('quantity'), 10) || 1;
    var item = { id: variant_id, quantity: qty };
    var selling_plan = $btn.attr('selling_plan');
    if (selling_plan) item.selling_plan = parseInt(selling_plan, 10);
    elAddItems([item], $btn);
  });

  $(document).on('click', "a[href='#atc']", function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $atcbtn = $('.el-checkout-button');
    var variant_id = parseInt($atcbtn.attr('variant_id'), 10);
    if (!variant_id) return;
    elAddItems([{ id: variant_id, quantity: 1 }], $btn);
  });

  /* ---------- Panier : rafraîchissement du tiroir ---------- */
  var cartRefreshSerial = 0;
  function refreshCartDrawer(options) {
    var drawer = document.querySelector('.el-cart-drawer');
    if (!drawer) { if (options && options.releaseWrite) cartWriteBusy = false; return; }
    if (options && options.releaseWrite) cartWriteAwaitingRead = true;
    var serial = ++cartRefreshSerial;
    var url = new URL(window.location.href);
    if (drawer.id.indexOf('el-cart-drawer-') === 0) url.searchParams.set('section_id', drawer.id.replace(/^el-cart-drawer-/, ''));
    drawer.setAttribute('aria-busy', 'true');
    return $.ajax({
      url: url.href,
      type: 'GET',
      dataType: 'html',
      cache: false,
      timeout: 12000,
      success: function (response) {
        // A slower earlier request must never replace a newer cart or remove its focused control.
        if (serial !== cartRefreshSerial || !drawer.isConnected) return;
        var $new = $('<div>').html(response);
        var newContent = $new.find('.el-cart-drawer-js').html();
        if (newContent === undefined) {
          setCartError(cartErrorMessage || 'Le panier n’a pas pu être actualisé. Utilise « Actualiser le panier » pour réessayer.');
          return;
        }
        var focusSnapshot = cartFocusSnapshot(drawer) || drawer.__elCartFocusSnapshot;
        if (newContent !== undefined) $('.el-cart-drawer-js').html(newContent);
        setCartError(options && options.preserveError ? cartErrorMessage : '');
        $('.el-cart-drawer-js').removeClass('el-loading-cart');
        elInitSliders('.el-cart-drawer-js');
        if (!options || !options.readOnly) removeShippingProtection();
        updateCartCountExcludeShipping();
        $(document).trigger('el:cart:refreshed');
        scheduleCartFocus(drawer, focusSnapshot);
      },
      error: function () {
        if (serial !== cartRefreshSerial || !drawer.isConnected) return;
        setCartError(cartErrorMessage || 'Le panier n’a pas pu être actualisé. Vérifie ta connexion puis utilise « Actualiser le panier ».');
      },
      complete: function () {
        if (serial === cartRefreshSerial && drawer.isConnected) {
          if (cartWriteAwaitingRead) { cartWriteBusy = false; cartWriteAwaitingRead = false; }
          drawer.setAttribute('aria-busy', 'false');
          $('.el-cart-drawer-js').removeClass('el-loading-cart');
        }
      }
    });
  }
  window.refreshCartDrawer = refreshCartDrawer;
  $(document).on('click', '[data-el-cart-retry]', function () {
    if (!cartWriteBusy) refreshCartDrawer({ readOnly: true });
  });
  // History restoration is not always reported as BFCache; all page shows get a fresh GET.
  window.addEventListener('pageshow', function () {
    refreshCartDrawer({ readOnly: true });
  });

  var cartCountSerial = 0;
  function updateCartCountExcludeShipping() {
    var serial = ++cartCountSerial;
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var $toggle = $('.el-cart-drawer-js .el-shipping-protection-toggle-wrapper');
        var shippingVariantId = $toggle.data('variant-id');
        var count = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id != shippingVariantId) count += item.quantity;
        });
        if (serial !== cartCountSerial) return count;
        $('.el-cart-count').text(count);
        if (count > 0) $('.el-cart-count').show(); else $('.el-cart-count').hide();
        return count;
      })
      .catch(function (err) { console.error('Cart count error:', err); });
  }
  window.updateCartCountExcludeShipping = updateCartCountExcludeShipping;

  /* ---------- Panier : quantités ---------- */
  $(document).on('click', '.el-cart-drawer-js .el-quantity-plus, .el-cart-drawer-js .el-quantity-minus', function () {
    if (!beginCartWrite()) return;
    var $btn = $(this);
    var $wrapper = $btn.closest('.el-line-item');
    var $input = $wrapper.find('.el-quantity-input');
    var key = $wrapper.data('key');
    var qty = parseInt($input.val(), 10) || 0;
    if ($btn.hasClass('el-quantity-plus')) qty++; else qty--;
    if (qty < 0) qty = 0;
    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: { id: key, quantity: qty },
      dataType: 'json',
      timeout: 12000,
      success: function () { refreshCartDrawer({ releaseWrite: true }); },
      error: failedCartWrite
    });
  });
  $(document).on('click', '.el-cart-drawer-js .el-line-item-remove', function () {
    if (!beginCartWrite()) return;
    var key = $(this).closest('.el-line-item').data('key');
    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: { id: key, quantity: 0 },
      dataType: 'json',
      timeout: 12000,
      success: function () { refreshCartDrawer({ releaseWrite: true }); },
      error: failedCartWrite
    });
  });

  /* ---------- Panier : protection anti-fuite (toggle) ---------- */
  $(document).on('click', '.el-cart-drawer-js .el-shipping-protection-toggle-wrapper', function () {
    $('.el-cart-drawer-js').addClass('el-loading-cart');
    var $btn = $(this);
    var variantId = $btn.data('variant-id');
    var isActive = $btn.hasClass('active');
    $btn.toggleClass('active');
    if (isActive) {
      $.getJSON('/cart.js', function (cart) {
        var itemToRemove = cart.items.find(function (item) { return item.variant_id == variantId; });
        if (itemToRemove) {
          $.ajax({
            url: '/cart/change.js', type: 'POST', data: { id: itemToRemove.key, quantity: 0 }, dataType: 'json',
            success: function () { refreshCartDrawer(); },
            error: function (err) { console.error('Remove failed', err); refreshCartDrawer(); }
          });
        } else {
          refreshCartDrawer();
        }
      });
    } else {
      $.ajax({
        url: '/cart/add.js', type: 'POST', data: { id: variantId, quantity: 1 }, dataType: 'json',
        success: function () { refreshCartDrawer(); },
        error: function (err) { console.error('Add failed', err); refreshCartDrawer(); }
      });
    }
  });

  /* Retire la protection si elle est seule dans le panier */
  function removeShippingProtection() {
    var $toggle = $('.el-cart-drawer-js .el-shipping-protection-toggle-wrapper');
    if (!$toggle.length) return;
    var variantId = $toggle.data('variant-id');
    $.getJSON('/cart.js', function (cart) {
      if (cart.items.length === 1 && cart.items[0].variant_id == variantId) {
        $.ajax({
          url: '/cart/change.js', type: 'POST', data: { id: cart.items[0].key, quantity: 0 }, dataType: 'json',
          success: function () { refreshCartDrawer(); },
          error: function (err) { console.error('Auto-remove shipping failed', err); }
        });
      }
    });
  }

  /* ---------- Panier : onglets d'upsell ---------- */
  $(document).on('click', '.el-cart-upsells-tab-item', function () {
    var $tab = $(this);
    var $wrapper = $tab.closest('.el-cart-upsells-wrapper');
    $wrapper.find('.el-cart-upsells-tab-item').removeClass('el-active').attr('aria-selected', 'false').attr('tabindex', '-1');
    $tab.addClass('el-active').attr('aria-selected', 'true').attr('tabindex', '0');
    var data_tab = $tab.attr('data_tab');
    $wrapper.find('.el-cart-upsells-tab-content-item').removeClass('el-active').hide();
    var $content = $wrapper.find('.el-cart-upsells-tab-content-item[data_tab="' + data_tab + '"]');
    $content.addClass('el-active').show();
    var $slider = $content.find('.slick-slider');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
      $slider.slick('refresh');
    }
  });
  $(document).on('keydown', '.el-cart-upsells-tab-item', function (e) {
    if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].indexOf(e.key) === -1) return;
    var wrapper = this.closest('.el-cart-upsells-wrapper');
    if (!wrapper) return;
    var tabs = Array.from(wrapper.querySelectorAll('.el-cart-upsells-tab-item'));
    var index = tabs.indexOf(this);
    if (e.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    else if (e.key === 'ArrowRight') index = (index + 1) % tabs.length;
    else if (e.key === 'Home') index = 0;
    else if (e.key === 'End') index = tabs.length - 1;
    e.preventDefault();
    tabs[index].click();
    tabs[index].focus({ preventScroll: true });
  });

  /* ---------- Compte à rebours evergreen ([data-el-countdown]) ----------
     data-hours : durée en heures. La date de fin est mémorisée par visiteur
     (localStorage, clé par section) et relancée à l'expiration. */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function elInitCountdowns() {
    document.querySelectorAll('[data-el-countdown]').forEach(function (el) {
      if (el.dataset.elCountdownInit) return;
      el.dataset.elCountdownInit = '1';
      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var key = 'el_countdown_' + (el.getAttribute('data-key') || 'default');
      var duration = hours * 60 * 60 * 1000;
      var end = 0;
      try { end = parseInt(window.localStorage.getItem(key), 10) || 0; } catch (e) { end = 0; }
      function reset() {
        end = Date.now() + duration;
        try { window.localStorage.setItem(key, String(end)); } catch (e) { /* stockage indisponible */ }
      }
      if (!end || end < Date.now() || end - Date.now() > duration) reset();
      var $h = el.querySelector('.el-countdown-hour-js');
      var $m = el.querySelector('.el-countdown-min-js');
      var $s = el.querySelector('.el-countdown-sec-js');
      function tick() {
        var distance = end - Date.now();
        if (distance < 0) { reset(); distance = end - Date.now(); }
        var h = Math.floor(distance / (1000 * 60 * 60));
        var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((distance % (1000 * 60)) / 1000);
        if ($h) $h.textContent = pad(h);
        if ($m) $m.textContent = pad(m);
        if ($s) $s.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }
  window.elInitCountdowns = elInitCountdowns;

  /* Éditeur de thème : ré-initialiser sliders et comptes à rebours quand une section est rechargée */
  document.addEventListener('shopify:section:load', function () {
    elInitSliders();
    elInitCountdowns();
  });
})(window.jQuery);
